import React from 'react'
import Link from 'gatsby-link'
import Intro from '../components/Intro/Intro'
import LogoGrid from '../components/LogoGrid/LogoGrid'
import IconGrid from '../components/IconGrid/IconGrid'
import Testimonial from '../components/Testimonial/Testimonial'
import Button from '../components/Button/Button'
import styles from './index.module.css'
import Helmet from 'react-helmet'

const IndexPage = props => {
  let introText =
    props.data.homeText.edges[0].node.childMarkdownRemark.frontmatter
  return (
    <div>
      <Helmet>
        <script src="https://identity.netlify.com/v1/netlify-identity-widget.js" />
      </Helmet>
      <Intro
        heading={introText.intro_heading}
        body={introText.intro_copy}
        qualifications={introText.qualifications}
      />
      <div className={styles.dell}>
        <img
          src="/assets/dell-technologies-logo.svg"
          alt="Dell Silver Partner"
        />
        Authorized Partner
      </div>
      <IconGrid
        heading="Our Solutions"
        subheading="Some subheading here."
        items={props.data.solutions.edges}
      />
    </div>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query homeQuery {
    homeText: allFile(filter: { sourceInstanceName: { eq: "homepage" } }) {
      edges {
        node {
          id
          childMarkdownRemark {
            frontmatter {
              intro_copy
              intro_heading
              qualifications {
                qualification
                notes
              }
            }
          }
        }
      }
    }
    team: allFile(filter: { sourceInstanceName: { eq: "team" } }) {
      edges {
        node {
          id
          childMarkdownRemark {
            html
            frontmatter {
              title
              position
              email
              phone
            }
          }
        }
      }
    }
    solutions: allFile(filter: { sourceInstanceName: { eq: "solutions" } }) {
      edges {
        node {
          id
          childMarkdownRemark {
            html
            fields {
              slug
            }
            frontmatter {
              title
              icon
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js